module.exports = "https://static.energy5.com/_next/static/images/rebatesBg-8e2f6b1169c0f47d5e5723deb7c65cc8.webp";